module.exports = __webpack_public_path__ + "static/img/jianshe.ff7391ee.png";